<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
</script>

<template>
    <AccordionItem value="dashboard" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'gauge-max']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Dashboard</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs">
            <div class="flex flex-col text-white">
                <RouterLink to="/dashboard/technical" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Technical</RouterLink
                >
                <RouterLink to="/dashboard/finance" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Finance</RouterLink
                >
                <RouterLink to="/dashboard/alerts" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Alerts</RouterLink
                >
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
